export default __webpack_public_path__ + "static/mokuChat-b05283893e87ef10df949a0a943a6021.svg";